import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addReviewsReplyFailure,
  //
  addReviewsReplySuccess,
  deleteReviewsReplyFailure,
  //
  deleteReviewsReplySuccess,
  editReviewsReplyFailure,
  //
  editReviewsReplySuccess,
  fetchReviewsReply as fetchReviewsReplyAction,
  fetchReviewsReplyFailure,
  fetchReviewsReplySuccess,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_REVIEWS_REPLY,
  DELETE_REVIEWS_REPLY,
  EDIT_REVIEWS_REPLY,
  FETCH_REVIEWS_REPLY,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchReviewsReplySaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review-reply?${query}`);
    yield put(fetchReviewsReplySuccess(data));
  } catch (e) {
    yield put(fetchReviewsReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching reviews!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review-reply/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addReviewsReplySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review-reply/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Reply added successfully!"));
      yield put(addReviewsReplySuccess());
    }
  } catch (e) {
    yield put(addReviewsReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editReviewsReplySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review-reply/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Reply updated successfully!"));
      yield put(editReviewsReplySuccess());
      // yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editReviewsReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteReviewsReplySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/review-reply/${payload}`);
    if (data) {
      yield put(successAlert("Reply deleted successfully!"));
      yield put(deleteReviewsReplySuccess());
      yield put(fetchReviewsReplyAction());
    }
  } catch (e) {
    yield put(deleteReviewsReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchReviewsReplyFlow() {
  yield takeEvery(FETCH_REVIEWS_REPLY, fetchReviewsReplySaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addReviewsReplyFlow() {
  yield takeEvery(ADD_REVIEWS_REPLY, addReviewsReplySaga);
}
export function* editReviewsReplyFlow() {
  yield takeEvery(EDIT_REVIEWS_REPLY, editReviewsReplySaga);
}
export function* deleteReviewsReplyFlow() {
  yield takeEvery(DELETE_REVIEWS_REPLY, deleteReviewsReplySaga);
}
export default function* ReviewsReplySaga() {
  yield all([
    fetchReviewsReplyFlow(),
    addReviewsReplyFlow(),
    editReviewsReplyFlow(),
    deleteReviewsReplyFlow(),
    getViewDataFlow(),
  ]);
}
